import { useTempStore } from '../../temp';

export const useSimulationInputData = () => {
	const { inputData } = useTempStore();

	return inputData;
};
